import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const Label = styled.label`
    user-select: none;
    display: flex;
    align-items: baseline;

    ${({ theme }) => theme.typography["Body/Regular/Text2"]}

    margin: auto 0;
    color: var(--svy-label-color);
`;

export const FieldWithLabelContainer = styled.div<{ disabled?: boolean }>`
    --svy-label-color: inherit;

    display: flex;

    &[data-orientation="vertical"] {
        flex-direction: column;
        label {
            padding-bottom: 8px;
        }
    }

    &[data-orientation="horizontal"] {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        label {
            padding-right: 8px;
        }
    }

    &[data-orientation="horizontal-reverse"] {
        flex-direction: row-reverse;
        justify-content: flex-end;
        align-items: center;
        label {
            padding-left: 8px;
        }
    }

    ${({ disabled, theme }) =>
        disabled &&
        css`
            --svy-label-color: ${theme.colors.neutral[400]};
        `}
`;
